<template>
  <div v-bind="$attrs" class="checkout-cart">
    <table>
      <tbody>
        <template v-for="line in products">
          <CartProduct
            :cart="cart"
            :line="line"
          />
        </template>
        <template v-for="line in fees">
          <tr>
            <td colspan="2">{{ line.name }}</td>
            <td>{{ formatPrice(line.total) }}</td>
          </tr>
        </template>
        <template v-for="discount in cart.discounts">
          <tr>
            <td colspan="2">
              <div class="flex flex-wrap">
                <Code
                  class="whitespace-nowrap mr-2"
                  :value="discount.code"
                />
                <div class="mr">{{ discount.name }}</div>
              </div>
            </td>
            <td>{{ formatPrice(-discount.applied) }}</td>
          </tr>
        </template>
      </tbody>
    </table>

    <div class="flex items-center justify-between pt-2">
      Gesamt
      <strong>{{ formatPrice(cart.total_discounted) }}</strong>
    </div>

  </div>
</template>

<script>
import CartProduct from 'Web/Checkout/CartProduct.vue';
import Code from 'Web/Shared/Code.vue';
import filter from 'lodash/filter';
import groupBy from 'lodash/groupBy';
import flatten from '@/helpers/flatten';
import formatPrice from '@/helpers/formatPrice';
import { computed } from 'vue';

export default {
  inheritAttrs: false,
  components: {
    CartProduct,
    Code,
  },
  props: {
    cart: {
      type: Object,
      required: true,
    }
  },
  setup(props) {
    function extract(type) {
      let lines = props.cart.lines ?? [];

      lines = filter(lines, { type });
      lines = groupBy(lines, line => line.name);
      lines = flatten(lines);

      return lines;
    }

    const fees = computed(() => [
      ...extract('shipping'),
      ...extract('surcharge'),
    ]);

    const products = computed(() =>
      extract('product')
    );

    return {
      fees,
      formatPrice,
      products,
    }
  }
}
</script>
